// export const SOCKET_SERVER_URL = 'https://api-develop.panthermediasystem.net';
export const SOCKET_SERVER_URL = 'https://api-prod.panthermediasystem.net';
// export const SOCKET_SERVER_URL = 'http://localhost:3600';
// export const SOCKET_SERVER_URL = 'https://0384-2402-4000-2380-b4aa-39f8-6c60-2639-8dfc.in.ngrok.io';


export const MESSAGE = {
    SEND_ROOM: 'SEND_ROOM',
    CREATE_GROUP: 'CREATE_GROUP',
    EDIT_GROUP: 'EDIT_GROUP',
    REMOVE_GROUP: 'REMOVE_GROUP',
    SEND_STATUS: 'SEND_STATUS',
    JOIN_ROOM: 'JOIN_ROOM',
    CALL_USER: 'CALL_USER',
    CALL_GROUP: 'CALL_GROUP',
    REJECT_CALL: 'REJECT_CALL',
    JOIN_CALL: 'JOIN_CALL',
    LEAVE_CALL: 'LEAVE_CALL',
    MEETING_SCHEDULE: 'MEETING_SCHEDULE'
};

export const STATUS = {
    OFFLINE: 0,
    ONLINE: 1,
    BUSY: 2,
    DND: 3
};

export const StatusType = 0 | 1 | 2 | 3;

export const TIME_WAIT = 60000;
